export class PkRequestTypes {
  static ArGetVATRate = "5ED6A8DF-B634-4F89-BE81-4359488D97D4";
  static AddDocumentToFavorites = "9E6AF495-641E-4381-BA86-0C15F22F3240";
  static RemoveDocumentFromFavorites = "F83555BA-24FF-44E3-8DD6-DAC2082D3E2C";
  static CalculateVatAmount = "502BD06B-9B89-43C3-9146-F990878DE636";
  static PkCalculateAmountWithoutVat = "A77D49AF-7834-488D-91D3-369C00091938";
  static GetRdDivisionRoleProperties = "C43FA1B2-C667-42B9-892E-EE654B10F760";
  static GetTechnicalDocumentationApprovers = "684A4AAE-B5DD-41D1-AE45-C2B6743B954A";
  static GetPacketID = "7AFF4D2D-ECBA-4A45-B64F-FFC80CDE4F12";
  static EDocumentConvertToAct = "EDD13944-A2D7-46E9-B2CE-29606D5C862A";
  static SignInfo = "2465212B-8A28-4A19-8D5A-62EABA0BD915";
  static IsDirectual = "2D6557F4-D46C-400C-A428-49980A8A793D";
  static GetApproversByObjects = "41FE0271-BBFD-4B9A-8B7A-002280000963";
  static ContractInfo = "146388B5-D7EB-4DDF-999C-451A696D025A";
  static ArSendToKa = "09ec28e6-77f6-4a56-be23-cc6fbb6f6894";
  static ObjectInfo = "AEC6089B-FE50-4787-9F25-2D3F9E2D2F10";
  static GetSameArDocuments = "2F32320C-14FC-40AE-8CDA-F03155863113";
  static GetDealorPayerByPartnerKCK = "65D07731-8942-43C2-B22B-78C6A1C92681";
  static GetObjectAndRealEstate = "2AAC725E-A001-4DAF-BEEF-FD35865DD8DA";
  static PkGetClientByContract = "42F38509-6671-4C51-A0A2-E6C2804F66CC";
  static RejectCards = "8A9442E7-2394-4489-A7B0-83B8098630AC";
  static SendActToDiadoc = "CFEA95F9-A476-42FF-BE79-194C18B1C2D1";
  static PkGetContractDate = "038B426D-82C1-44FE-B2C0-7917F745FCCB";
  static RevokeTemplateInDiadoc = "AE753D4B-8432-4482-96D6-4311575E06EF";
  static GetInfoFromMemoSettingsCard = "06822B73-3727-462B-A619-2BF39C488458";
  static PkCheckCustomSubject = "8AC34094-4189-4D9C-9E92-2642B5CC6F1C";
  static PkWrkWithTemplateWeb = "1A26C0B9-0958-4CB9-B1BF-229405E817F7";
  static PkCheckVgoCard = "EAB9666E-D092-4FB3-BCDA-A96FA7B2893A";
  static PkGetVgoIdRequest = "CD9231A2-1447-4364-A9E9-91DB8B2B6CBA";
  static PkCheckActiveTasks = "47B7CA72-B290-407C-B431-13DBD0F339CA";
  static CompleteAutoSigningProcess = "9254FD19-6757-4F87-92AA-3C1E0B2B5480";
  static BankAccountInfo = "345D01CD-1E69-4DC4-BD08-80E621C64DB8";
  static PkContractGetDepartmentRequest = "1498AAC3-19AB-443B-A852-B0480E82C98D";
  static PkContractGetInfoByPartner = "B59F954E-1DD3-409A-8225-959ABE7CC310";
  static ArCheckRelatedConcession = "2CEE1EC3-4B47-4984-BE0B-373003A18155";
  static ArCheckEditArticleIDP = "FF540827-C234-47E5-B7A7-17973FD3307B";
  static ArCheckArticleUsageInAdditionalAgreement = "D9AE58A5-FB35-41B3-818B-1EEE4CCF25DF";
  static CheckVoidTheContract = "A05D61DA-FEC3-4E6B-BF0B-FD52E765F72E";
  static ArGetMostRecentDocumentDateFromTheLinked = "CFB5619A-5D50-4F68-9BB6-490E926EF0F2";
  static PkTCOfferGetApprovers = "F5D6BDBC-6BFD-4CFE-B6BB-98EA7F1A1BD5";
  static PkTCOfferGetEmployee = "D2D83AAA-AB87-48BE-A9DC-86C375703606";
  static PkRejectClientDocument = "379654D2-07B4-3D0A-6B7A-1245B69AB420";
  static ArContractMakeItValid = "3DA8D6B3-34EE-4F1F-97C5-D5C0C014897D";
  static PkCheckUserHasTasks = "35C04D64-54B8-4C09-8DFB-FF560425DCEA";
  static PkTCOfferGetUserName = "124DC14A-55EF-4992-8B76-80F5908FBC81";
  static PkTCOfferGetUserDepartment = "619654D2-07B5-4D0A-8B7A-6255B69AB419";
  static PkGetContractInfoForCovenant = "A50391A8-4AEE-43DF-AAE5-D037DCF58C74";
  static PkPrepareOutgoingForSendingDiadoc = "B937C322-B42B-4E4B-A83D-9606B9155707";
  static CheckWorkOrderContractor = "D5DBF388-CF82-4195-BCFA-7B384196E9B1";
  static PkValidateSignTypeSelecting = "7AEC6560-5D06-41F2-94CC-33D55DB0BC3C";
  static ArGetExistContractEdoRequestID = "9D67CE0C-A116-47A8-8E58-FE79561FA7C7";
  static ArGetAgreementEDORequestID = "CC85EAF9-A1FE-4FED-9C34-47298F5FB456";
  static ArGetSetCancelEDORequestID = "080F7A8D-7CAD-4BC3-B4DE-C8C4F2F03527";
  static ArAttachDocumentsFromEDRequestID = "7FAF831F-A06F-408B-86A8-301D454A6d2A";
  static PkPkGetSetUserSubsetsRequestID = "865884E8-D13A-4ECA-8233-389F71C479A4";
  static IrdGetNotifyUsersRequestID = "af251e28-b129-42da-b58c-3145250b8d0b";
  static IrdCheckExistingVersions = "2617A923-1CAC-4913-B131-0FFE4D4F3DFE";
  static IrdGetTepsByKindRequest = "5CE4DBE9-C151-4739-85DD-60A611C253BE";
  static IrdGetVersionsRequest = "DB087EFB-E257-4ACA-B878-77D3C5DBCB62";

  /**Формирование описи по пакету оригиналов документов */
  static PkGetCourtContractPartners = "5EC36BC9-6CA6-4E51-824E-B8145F8FC3A6";
  static ArAddWordFileWithDocsToContract = "D8D1EBC5-FDFA-46BC-B85F-00B11DA1CC39";
  /** Реквест на получение стикерных статей. */
  static PkGetArticleStickersByParent = "1DDBBE96-0D4F-4954-A569-832240C374E3";
  /** Получение статей стикера из договорного документа по RowID. */
  static PkGetArticleStickersFromContacrtByParent = "ED944A14-9411-43E5-A063-28299592B936";
  static GetDepartmentSystemInfo = "0271D9E2-28A5-4278-AD8A-4C0DC30C6BA4";
  /** Реквест на получение суммы по статье договора из таблицы текущие суммы. */
  static PkGetArticleAmountFromContractBySticker = "8CC8A556-60B9-4533-944B-BB46C0B33FD9";
  static ArContractSetReasonChanges = "E08AF387-9470-4ABA-A2D1-560C1467FA30";
  static PkGetEventPeriodicity = "9F5AD89E-7DE4-4067-9496-BCC8B9BC6918";
  /// Реквест для получения темы входящего документа из исходящего.
  static ChGetThemeTemplateIncomming = "5C70D3CF-40DD-40CF-8ED0-AC0550F7B7DA";
  static PkCopyAllCovenants = "0B1E0E1B-5710-4EB3-83A4-4E743BCBC06E";

  /** Реквест на получение сообщений ЕКС. */
  static PkGetEksMessagesInfo = "70AC0FE8-1B4E-4717-90C7-6E5C752BDD5F";

  /** Реквест на обновление сообщений ЕКС. */
  static PkUpdateEksMessagesInfo = "6C7F5733-46CB-40A3-953C-C4C93C94DCD1";

  /** Обновление или создание конкретного договора в тессе из мдс по коду Директум (ЕСУД). */
  static PkUpdateContractFromMdsRequest = "69D2498B-CC82-48B9-9EC7-E305B34310FD";

  static ArCheckContractCategoryInKd = "8A848F9C-68E5-4780-AB3B-C073ED1AB048";
  static ArSendToKd = "D4475C77-665B-4FCC-9C8F-F75EEF1F0986";

  static ArContractGetRolePerformers = '024A1C9D-7302-4B11-A0A1-D221AC732EB9';

  static ArGetxchangeRateByCurrency = '292FDA97-C2F6-4A9E-88AB-79CC514D2EDB';
  static PkGetDepartmentRolesRoleUsersID = 'A6E82AC5-CA3A-4F20-997D-33029B75A6F9';
  static PkGetPartnerKCKByExternalID = '69C05FA1-F953-4973-B57A-3D1AFD0048B4';
  static PkGetAnalyticsStickersAndMethodID = 'A53289B6-DA3B-4A06-9010-A770AD773030';
  /** Запрос на Пересчет суммы в Первичном документе {A399C5E2-DDDE-48C2-9778-A82E7A1D8C96} */
  static ArActRecalculateAmountsRequestID = 'A399C5E2-DDDE-48C2-9778-A82E7A1D8C96'

  /** Реквест для получения ИНН Контрагентов по их ExternalID. */
  static PkGetINNbyExtIDPartnersRequest = 'C98F037B-BCE7-41C0-8041-DA824E74AEDA';

  /** Запрос на распознавание документа. */
  static DocumentRecognizeStartRequest = '0B82F996-ACEF-417B-9E53-67947BB336A5';

  /** Проверка статуса и получение результата распознавания документа. */
  static DocumentRecognizeCheckStatusRequest = 'C31BAB1D-F741-4DBE-895D-6AE084256904';

  /** Получение виртуального подписанта */
  static PkGetVirtualSignerByDepartment = '6534F234-BF94-4CDE-9459-9C50B391C1B2';

  /** Запрос доступа для создания соглашения о расторжении */
  static PkAgreementTerminationContractAccessRequest = '4BAA3FAB-9EF4-4E36-82D2-0F5F3AC539E9';
  
  /** Запрос актуальных PartnerAutomated и PartnerDepartmentID */
  static ArContractPartnerstInfoRequest = 'C84F7B16-CFBF-47CD-BC4E-E1C4D8B631AF';
  
  /** Получение ID типа карточки по ID карточки */
  static ArContractGetContractKindIDByCardID = "12CA4975-B0D5-45BB-B5FA-7726A285BE18";

 /** Запрос доступа для создания уступки  */
  static PkAgreementCessionContractAccessRequest = '59197016-5033-4921-BA5A-E1A340780885';

   static PkGetUncomplitedChildTasksRequest = '8F704056-24F9-4989-8931-52E9E625C5F1';

  /** Реквест на получение информации по конверту. */
  static PkGetEnvelopeInfo = "474FE541-C686-445A-8F8B-F97450AA69F5";

  /** Реквест на получение связанных с карточкой ссылок. */
  static PkGetReferencesInfo = "2E76126F-426D-4439-B4C6-A56293DFB58F";
   /** Проверка наличия заполненной матрицы. */
   static ArContractCheckFilledMatrixExistsRequest = 'E07360B3-F352-4BD5-8414-D903905AF029';

   /** Запрос доступа для запуска согласования ДС. */
  static ArContractIsCanStartApprovalAdditionalAgreementRequest = '32B35E19-631D-4390-B10F-C030A8C17966';

  /** Реквест на получение значения поля. */
  static PkGetFieldValue = "11B5F835-9597-44EF-9AFE-7E4397E1B4F3";

  // Реквест на удаление кэша распознавания
  static DocumentRecognitionClearCacheRequest = "988D3F88-1662-4E88-828F-F541FB2E1FC0";

  // Проверка наличия статьи по параметрам в документе.
  static PkContractCheckArticleExists = "A0DDB413-7FEE-4946-AB34-1D85A6719A79";

  // Проверка наличия указанных в карточке этапов
  static ArContractCheckMatrixUpToDate = "398E59D8-7280-4995-AADC-452AB118149A";

  // Получение текста полномочия из карточки доверки (фактически вписанного из КД, а не из ссылки на карточки полномочий).
  static ArPOAGetCredentialsTextRequest = "7519D994-D2F5-48E7-9FD1-22BE28ED4105";
  
  // Получить subject карточки договора.
  static PkGetContractSubjectRequest = "D4C1B08B-7752-49FE-84C1-DFBCEEDF2382";

  // Проверка наличия статьи по параметрам в документе.
  static PkOutgoingGetCulpritInfos = "7FC73345-303E-4CAF-A7FD-9AFBAD95074C";

  // Проверка наличия статьи по параметрам в документе.
  static PkOutgoingGetActArticleIdpsInfos = "4B9845CC-35DD-43FF-84ED-796BEB7D4B34";

  // Реквест на перерегистрацию доверенности.
  static ArPOARegisterRequest = "385BE49E-FDB8-4CA3-B791-585911AC403F";

  //Реквест на получение доступности для редактирования поля "Сумма к удержанию".
  static PkOutgoingGetInfoForClaimHoldingAmountRequest = "F0E1DD3B-5404-4CF1-AC7A-495C80282F6F";

  // Проверка факта создания КСД на основе ЭД.
  static ArContractCheckCreatedOnBaseArEDocumentRequest = "98958060-9FCF-4C99-90B7-48A63F5FC51A";

  //Удаление файлов из категорий Печатные Формы, Полный пакет и удаление информации о подписании в Диадок в таблицах PkDiadocCommonInfo PkDiadocInfo.
  static CleanDiadocInfoRequest = "08DC43F9-BDCD-47CF-8B0A-1678225400A2";

    // Реквест на получение информации по организации КСК (физ.лица).
    static PkOutgoingGetIndividualsKCKRequest = "5C0133E7-030D-4115-BB23-B30FF8423597";

  // Реквест на добавление/обновление сущности мест уплаты налогов из МДМ.
  static PkUpdateFinanceTaxAuthorityRegistrationByMessageRequest = "E19B3216-7D49-4D78-8B5E-DCC03E902A6D";

  // Реквест на очистку ошибки Диадок.
  static PkClearDiadocErrorRequest = "14CBF3A8-85B5-4E5C-9F67-D8E8FBB8E01B";

  static PkCheckDeputyUsers = "67DEEB31-A80D-4F05-BD42-9969365A9A74";
  
  // Реквест на добавление/обновление сущности персональных данных из МДМ.
  static PkUpdateHRPersonalDataByMessageRequest = "E9AA09D0-03BC-4A38-B217-799A93DEEE9E";

  static PkGetFRCOwnerRequest = "71C2105D-4852-4DF7-98AB-C817F95A40F8";

  static PkGetContractCategoryIsFinancialAnalyticRequestID = "78C8AB16-8225-4826-9DC8-F9FDEBC3340D";

  // Реквест  urlа авторизации в Контур.Экстерн.
  static ArGetAuthorizationUrlForKonturExtern = "9389F9E7-0253-49D0-ABE0-66582B4E6B6A";

  // Реквест авторизации в Контур.Экстерн.
  static ArAuthorizeWithKonturExtern = "1A3878B8-BCE9-43D5-8E30-64D65477FDBD";

  // Реквесто проверки множественных ЮЛ среди КСК по InstanceID
  static PkCheckMultipleKCKLegalsInListRequest = "52EE4984-8EF1-4C9A-8082-38B737727F99";
  
  // Реквест для получения дочерних категорий договора.
  static PkGetChildContractCategoryRequest = "3BD2F831-C782-4C0E-9653-E85021D89FB7";

  // Реквест на создание карточки КСД из АУД.
  static PkCreateContractFromAUDRequest = "22088A99-4401-4907-88BC-2F4E50712D6D";
}
